import _ from 'lodash';

export const getErrorText = (e: Error) => {
  // @ts-expect-error pubnub override default error
  console.error('pubnub', e.status || e.message);

  // @ts-expect-error pubnub override default error
  if (e.status && e.status.error) {
    return _.get(e, 'status.errorData.error.message', '');
  }

  return e.message;
};
